<template>
  <button
    class="border-text-gray-100 inline-flex items-center justify-center rounded-full border px-4 py-1 font-medium text-gray-100 duration-100 hover:border-white hover:bg-white/10 hover:text-white">
    <slot />
  </button>
</template>
